import ReactGA from "react-ga4";

const useAnalyticsEventTracker = (category="Botão WhatsApp") => {
  const eventTracker = (action = "Clique no botão do WhatsApp", label = "Botão WhatsApp") => {
    ReactGA.event({category, action, label});
  }
  return eventTracker;
}
export default useAnalyticsEventTracker;